import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const PromptCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: theme.spacing(-5),
  marginBottom: theme.spacing(-2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-1),
  },
  '& a': {
    textDecoration: 'none',
    color: colors.black,
  },
  '& .prompt': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    background: colors.lightGrey,
    padding: theme.spacing(0.5),
    borderRadius: 12,
    cursor: 'pointer',
    '& h3': {
      colors: colors.text,
      fontSize: fontSizes.small,
      fontWeight: 600,
      margin: `3px 5px`,
      [theme.breakpoints.down('xs')]: {
        margin: `2px 4px`,
        fontSize: '0.8rem',
      },
    },
  },
}))

export const HeadImg = styled('img')(({ theme }) => ({
  width: '100%',
  height: 60,
  marginTop: 8,
  marginBottom: -5,
  borderRadius: '6px 6px 0 0',
}))

export const ChampOuterCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(0, 1),
  minHeight: 460,
  [theme.breakpoints.down('sm')]: {
    minHeight: 400,
  },
  '& .largeChamp': {
    display: 'block',
    marginTop: theme.spacing(0),
    height: 210,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

export const MobileChampCon = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
}))
